import React, { useContext } from "react";
import CertificationContext from "module/certification/context/CertificationContext";
import { CertificationInterface } from "module/certification/types";
import CertificationStateLabelField from "module/certification/enrichedComponent/stateField/CertificationStateLabelField";

const CertificationStateLabelFieldContainer: React.FC = () => {
  const { entity } = useContext(CertificationContext);
  const { state } = entity as CertificationInterface;

  return <CertificationStateLabelField {...{ state }} />;
};

export default React.memo(CertificationStateLabelFieldContainer);
